import React, { Component } from 'react';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectionCard from '../LandingPageNew/LandingSubComponents/SelectionCard';
import view, { borders, validation, formView, propertyType } from '../../Enums';
import DropdownMenu from '../../common/DropdownMenu';
import * as IMAGES from '../../Images';
import SlidingPane from '../../common/react-slider-pane';
import { NavLink } from 'react-router-dom';
import { Event } from '../LandingPageNew/Tracking/Track';
import { guc } from '../../services/Localisation';

//TODO: Handle dropdown click outside dropdown
//TODO: Account for trnaslations in dropdowns
class FormHome2 extends Component {
  state = {
    adressBorder: borders.NORMAL_BORDER,

    showDropdown_are_you_a_owner: false,
    showDropdown_occupancy_status: false,
    showDropdown_struct_type: false,
    occupancyStatusList: {
      Vacant: 'Vacant',
      'Occupied By Self': 'Occupied By Self',
      'Occupied By Tenant': 'Occupied By Tenant'
    },
    areYouAnOwner: {
      Yes: 'Yes',
      No: 'No'
    },
    structTypeList: {
      Apartment: 'Apartment',
      'Independent House': 'Independent House',
      'Builder Floor': 'Builder Floor',
      Villa: 'Villa',
      Other: 'Other'
    }
  };
  constructor() {
    super();
    // this.setWrapperRef = this.setWrapperRef.bind(this);
    // this.setWrapperRef3 = this.setWrapperRef3.bind(this);
    // this.setWrapperRef2 = this.setWrapperRef2.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    Event('Partner Page Step 2 form - Home', 'Step 2 home form viewed', '', '');
    const occupancyStatusList = {
      Vacant: guc('Vacant','Vacant'),
      'Occupied By Self': guc('occupied_by_self','Occupied By Self'),
      'Occupied By Tenant': guc('occupied_by_tenant','Occupied By Tenant')
    };
    const areYouAnOwner = {
      Yes: guc('Yes','Yes'),
      No: guc('No','No')
    };
    const structTypeList = {
      Apartment: guc('Apartment','Apartment'),
      'Independent House': guc('independent_house','Independent House'),
      'Builder Floor': guc('builder_floor','Builder Floor'),
      Villa: guc('Villa','Villa'),
      Other: guc('Other','Other')
    };
    this.setState({occupancyStatusList,areYouAnOwner,structTypeList});
    // document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside(event) {
    if (
      document.getElementsByClassName('structure')[0].contains(event.target)
    ) {
      // inside
    } else {
      // outside

      this.setState({
        showDropdown_struct_type: false
      });
    }
    if (
      document.getElementsByClassName('occupancy')[0].contains(event.target)
    ) {
      // inside
    } else {
      // outside

      this.setState({
        showDropdown_occupancy_status: false
      });
    }
    if (document.getElementsByClassName('owner')[0].contains(event.target)) {
      // inside
    } else {
      // outside

      this.setState({
        showDropdown_are_you_a_owner: false
      });
    }
  }
  render() {
    let gc = this.props.getContent;
    let guc = this.props.getUniversalContent;
    let gs = this.props.getStyle;
    let gi = this.props.getImage;

    return (
      <React.Fragment>
        {this.props.globalData.form_translations && (
          <div
            style={{
              height:
                this.props.viewMode == view.DESKTOP
                  ? '750px'
                  : this.props.screenheight - 80 + 'px',
              overflowY:
                this.props.viewMode == view.DESKTOP ? 'visible' : 'scroll'
            }}
          >
            {this.props.viewMode == view.DESKTOP && (
              <NavLink
                exact
                to={
                  this.props.globalData.locale
                    ? '/' + this.props.globalData.locale
                    : '/'
                }
                style={{ textDecoration: 'none', color: '#ffffff' }}
              >
                <img src={gi('OYO_WHITE')} style={gs('form1_icon')} />
              </NavLink>
            )}
            {/*<div*/}
            {/*  style={{*/}
            {/*    height: this.props.screenheight-80 + 'px',*/}
            {/*  }}*/}
            {/*>*/}
            <div style={gs('text_div_form_one')}>
              <span style={gs('form1_step_one_text')}>{gc('step_2')}</span>
              <span style={gs('form1_step_two_text')}>{' ' + gc('of_2')}</span>

              <div style={gs('lets_start_contact')}>{gc('tell_us_more')}</div>
              <div style={gs('all_communications_with')}>
                {gc('all_communications_with')}
              </div>
            </div>

            <div style={gs('type_of_property_parent')}>
              <div style={gs('input_label_form')}>
                {gc('formstep1_typeOfProperty')}
              </div>

              <div style={gs('type_of_property_flex_parent')}>
                <SelectionCard
                  width={'48%'}
                  height={'56px'}
                  viewMode={this.props.viewMode}
                  selected={
                    this.props.globalData.type_of_property ===
                    propertyType.HOTEL
                  }
                  info_icon={gi('info_icon')}
                  type_icon={gi('hotel_icon')}
                  tick={gi('green_tick')}
                  type_text={gc('Hotel')}
                  type_style_tag={'hotel_icon'}
                  onClick={() => {
                    this.props.switchFormTwoView(formView.STEP_TWO_HOTEL);
                    this.props.globalActions.updatePropertyType(
                      propertyType.HOTEL
                    );
                  }}
                />

                <SelectionCard
                  width={'48%'}
                  height={'56px'}
                  viewMode={this.props.viewMode}
                  selected={
                    this.props.globalData.type_of_property === propertyType.HOME
                  }
                  info_icon={gi('info_icon')}
                  type_icon={gi('house_icon')}
                  tick={gi('green_tick')}
                  type_text={gc('Home')}
                  type_style_tag={'house_icon'}
                  onClick={() =>
                    this.props.globalActions.updatePropertyType(
                      propertyType.HOME
                    )
                  }
                />
              </div>
            </div>

            <div style={gs('form1_input_parent')}>
              <div style={gs('input_label_form')}>{gc('formHome_address')}</div>
              <input
                className="hideArrow mobile"
                style={{
                  ...gs('form1_input'),
                  border: this.props.homeBorderAddress
                    ? this.state.adressBorder
                    : borders.RED_BORDER
                }}
                placeholder={gc('formHome_address_placeholder')}
                type="text"
                required
                autoComplete="new-password"
                value={
                  this.props.globalData.formData
                    ? this.props.globalData.formData.hotel_address
                    : ''
                }
                onChange={e => {
                  Event(
                    'Partner Page Step 2 form - Home',
                    'Property address entered on Step 2 home form page',
                    '',
                    ''
                  );
                  this.props.validate(e.target.value, validation.HOME_ADDRESS);
                  this.props.globalActions.dataUpdate(
                    'hotel_address',
                    e.target.value
                  );
                }}
                onFocus={event => {
                  this.setState({
                    adressBorder: borders.ACTIVE_BORDER
                  });
                }}
                onBlur={event => {
                  this.setState({
                    adressBorder: borders.NORMAL_BORDER
                  });
                }}
              />
            </div>

            <div style={gs('form1_input_parent')} className={'structure'}>
              <div style={gs('input_label_form')}>
                {gc('formHome_structType')}
              </div>
              <div
                style={{
                  ...gs('dropdownDivForm'),
                  border: this.props.homeBorderStructureType
                    ? borders.NORMAL_BORDER
                    : borders.RED_BORDER
                }}
                // ref={this.setWrapperRef}

                onClick={() =>
                  this.setState({
                    showDropdown_struct_type: !this.state
                      .showDropdown_struct_type
                  })
                }
              >
                {this.props.globalData.formData.structure_type_home}
                <img
                  src={IMAGES.DOWN_ARROW}
                  className={'hover'}
                  style={gs('img_form_down_dropdown')}
                />
              </div>
              {this.state.showDropdown_struct_type &&
                this.props.viewMode === view.DESKTOP && (
                  <DropdownMenu
                    showScrollBar
                    extraStyle={{
                      height: '100px',
                      width: '407px',
                      top: '74px'
                    }}
                    s={Object.values(this.state.structTypeList)}
                    category={'Partner Page Step 2 form - Home'}
                    action2={'Structure type entered on Step 2 home form page'}
                    k={(type, value) => {
                      this.props.validate(
                        value,
                        validation.HOME_STRUCTURE_TYPE
                      );
                      this.setState({ showDropdown_struct_type: false });
                      this.props.globalActions.dataUpdate(
                        'structure_type_home',
                        value
                      );
                    }}
                    t={this.state.showDropdown_struct_type}
                    name="structure_type"
                  />
                )}
            </div>

            <div style={gs('form1_input_parent')} className={'occupancy'}>
              <div style={gs('input_label_form')}>{gc('formHome_status')}</div>
              <div
                style={gs('dropdownDivForm')}
                // ref={this.setWrapperRef2}
                onClick={() =>
                  this.setState({
                    showDropdown_occupancy_status: !this.state
                      .showDropdown_occupancy_status
                  })
                }
              >
                {this.props.globalData.formData.occupancy_status}
                <img
                  src={IMAGES.DOWN_ARROW}
                  className={'hover'}
                  style={gs('img_form_down_dropdown')}
                />
              </div>
              {this.state.showDropdown_occupancy_status &&
                this.props.viewMode === view.DESKTOP && (
                  <DropdownMenu
                    showScrollBar
                    extraStyle={{
                      height: '100px',
                      width: '407px',
                      top: '74px'
                    }}
                    s={Object.values(this.state.occupancyStatusList)}
                    category={'Partner Page Step 2 form - Home'}
                    action2={'Occupancy status entered on Step 2 form page'}
                    k={(type, value) => {
                      this.setState({ showDropdown_occupancy_status: false });
                      this.props.globalActions.dataUpdate(
                        'occupancy_status',
                        value
                      );
                    }}
                    t={this.state.occupancyStatusList}
                    name="occupancy_status"
                  />
                )}
            </div>

            <div style={gs('form1_input_parent')} className={'owner'}>
              <div style={gs('input_label_form')}>{gc('formHome_owner')}</div>
              <div
                style={{
                  ...gs('dropdownDivForm'),
                  marginBottom:
                    this.props.viewMode == view.MOBILE ? '86px' : '16px'
                }}
                // ref={this.setWrapperRef3}
                onClick={() =>
                  this.setState({
                    showDropdown_are_you_a_owner: !this.state
                      .showDropdown_are_you_a_owner
                  })
                }
              >
                {this.props.globalData.formData.are_you_a_owner}
                <img
                  src={IMAGES.DOWN_ARROW}
                  className={'hover'}
                  style={gs('img_form_down_dropdown')}
                />
              </div>
              {this.state.showDropdown_are_you_a_owner &&
                this.props.viewMode === view.DESKTOP && (
                  <DropdownMenu
                    category={'Partner Page Step 2 form - Home'}
                    action2={
                      'Are you a owner or not selected on Step 2 home form'
                    }
                    showScrollBar={false}
                    extraStyle={{
                      height: '100px',
                      width: '407px',
                      top: '74px'
                    }}
                    s={Object.values(this.state.areYouAnOwner)}
                    k={(type, value) => {
                      this.setState({ showDropdown_are_you_a_owner: false });
                      this.props.globalActions.dataUpdate(
                        'are_you_a_owner',
                        value
                      );
                    }}
                    t={this.state.areYouAnOwner}
                    name="are_you_a_owner"
                  />
                )}
            </div>
            {/*</div>*/}

            <div style={gs('button_parent_form')}>
              {this.props.viewMode == view.DESKTOP && (
                <div
                  onClick={() => {
                    Event(
                      'Partner Page Step 2 form - Home',
                      'Back button clicked on Step 2 home form page',
                      '',
                      ''
                    );
                    this.props.backToStepOne();
                  }}
                  style={gs('button_left_form')}
                  className={'hover'}
                >
                  <span style={gs('button_left_form_text')}>
                    <img
                      style={{
                        position: 'relative',
                        top: '2px',
                        marginRight: '8px'
                      }}
                      src={gi('gray_arrow_left')}
                    />
                    {gc('back_to_step_1')}
                  </span>
                </div>
              )}

              <div
                onClick={this.props.validateCurrentForm}
                style={gs('button_right_form')}
                className={'hoverColor'}
              >
                <span style={gs('button_right_form_text')}>
                  {guc('next_step')}
                  <img
                    style={{
                      marginLeft: '8px',
                      position: 'relative',
                      top: '2px'
                    }}
                    src={gi('white_arrow_right')}
                  />
                </span>
              </div>
            </div>

            <SlidingPane
              style={{
                zIndex: '5',
                height: '20%'
              }}
              className="structureTypeDropdown"
              overlayClassName="some-custom-overlay-class"
              from="bottom"
              isOpen={
                this.state.showDropdown_struct_type &&
                this.props.viewMode != view.DESKTOP
              }
              onRequestClose={() => {
                // triggered on "<" on left top click or on outside click
                this.setState({ showDropdown_struct_type: false });
              }}
            >
              <DropdownMenu
                extraStyle={{ width: '100%', height: '100%' }}
                s={Object.values(this.state.structTypeList)}
                k={(type, value) => {
                  this.props.validate(value, validation.HOME_STRUCTURE_TYPE);
                  this.setState({ showDropdown_struct_type: false });
                  this.props.globalActions.dataUpdate(
                    'structure_type_home',
                    value
                  );
                }}
                t={this.state.showDropdown_struct_type}
                name="structure_type"
                slideDown={this.props.slideDown}
              />

              <br />
            </SlidingPane>

            <SlidingPane
              style={{
                zIndex: '5',
                height: '20%'
              }}
              className="occupancyStatus"
              overlayClassName="some-custom-overlay-class"
              from="bottom"
              isOpen={
                this.state.showDropdown_occupancy_status &&
                this.props.viewMode != view.DESKTOP
              }
              onRequestClose={() => {
                // triggered on "<" on left top click or on outside click
                this.setState({ showDropdown_occupancy_status: false });
              }}
            >
              <DropdownMenu
                extraStyle={{ width: '100%', height: '100%' }}
                s={Object.values(this.state.occupancyStatusList)}
                k={(type, value) => {
                  this.setState({ showDropdown_occupancy_status: false });
                  this.props.globalActions.dataUpdate(
                    'occupancy_status',
                    value
                  );
                }}
                t={this.state.occupancyStatusList}
                name="occupancy_status"
                slideDown={this.props.slideDown}
              />

              <br />
            </SlidingPane>

            <SlidingPane
              style={{
                zIndex: '5',
                height: '20%'
              }}
              className="occupancyStatus"
              overlayClassName="some-custom-overlay-class"
              from="bottom"
              isOpen={
                this.state.showDropdown_are_you_a_owner &&
                this.props.viewMode != view.DESKTOP
              }
              onRequestClose={() => {
                // triggered on "<" on left top click or on outside click
                this.setState({ showDropdown_are_you_a_owner: false });
              }}
            >
              <DropdownMenu
                extraStyle={{ width: '100%', height: '100%' }}
                s={Object.values(this.state.areYouAnOwner)}
                k={(type, value) => {
                  this.setState({ showDropdown_are_you_a_owner: false });
                  this.props.globalActions.dataUpdate('are_you_a_owner', value);
                }}
                t={this.state.areYouAnOwner}
                name="are_you_a_owner"
                slideDown={this.props.slideDown}
              />

              <br />
            </SlidingPane>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormHome2);
